import * as React from "react";
const SvgEmptyStatePropertySearch = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 250.185,
	height: 124.679,
	viewBox: "0 0 250.185 124.679",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_6",
	"data-name": "Group 6",
	transform: "translate(0 0)"
}, /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_73",
	"data-name": "Ellipse 73",
	cx: 12.298,
	cy: 12.298,
	r: 12.298,
	transform: "translate(56.011 77.378)",
	fill: "#e4e4e4"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_598",
	"data-name": "Path 598",
	d: "M352.489,519.474A12.3,12.3,0,0,0,372.98,532.49a12.3,12.3,0,1,1-20.492-13.016Z",
	transform: "translate(-293.26 -438.013)",
	opacity: .2
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_599",
	"data-name": "Path 599",
	d: "M246.619,325.819h.034l.608,34.866h-1.284Z",
	transform: "translate(-178.277 -236.143)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_74",
	"data-name": "Ellipse 74",
	cx: 24.795,
	cy: 24.795,
	r: 24.795,
	transform: "translate(18.632 29.45)",
	fill: "#e4e4e4"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_600",
	"data-name": "Path 600",
	d: "M220.218,360.416a24.8,24.8,0,0,0,41.315,26.242,24.8,24.8,0,1,1-41.315-26.242Z",
	transform: "translate(-195.099 -322.732)",
	opacity: .2
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_601",
	"data-name": "Path 601",
	d: "M154.621,197.087h.068l1.226,70.3h-2.589Z",
	transform: "translate(-111.127 -142.842)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1225",
	"data-name": "Rectangle 1225",
	width: 113.649,
	height: 33.69,
	transform: "translate(93.251 88.157)",
	fill: "#f0f0f0"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1226",
	"data-name": "Rectangle 1226",
	width: 13.252,
	height: 26.728,
	transform: "translate(143.449 95.119)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1227",
	"data-name": "Rectangle 1227",
	width: 100.397,
	height: 30.995,
	transform: "translate(99.876 48.402)",
	fill: "#f0f0f0"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_602",
	"data-name": "Path 602",
	d: "M589.494,273.811H468.739a1.011,1.011,0,0,1-.7-1.739l33-31.722V226.533a1.012,1.012,0,0,1,1.011-1.011h6.514a1.012,1.012,0,0,1,1.011,1.011v5.614l2.493-2.4a22.4,22.4,0,0,1,30.5-.507l47.6,42.806a1.011,1.011,0,0,1-.676,1.762Z",
	transform: "translate(-379.041 -223.5)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_603",
	"data-name": "Path 603",
	d: "M442.32,204.421h0a6.4,6.4,0,0,1,6.4,6.4v8.647h-12.8v-8.647A6.4,6.4,0,0,1,442.32,204.421Z",
	transform: "translate(-315.941 -148.158)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_604",
	"data-name": "Path 604",
	d: "M528.413,204.829h0a6.4,6.4,0,0,1,6.4,6.4v8.647h-12.8V211.23A6.4,6.4,0,0,1,528.413,204.829Z",
	transform: "translate(-378.338 -148.454)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_605",
	"data-name": "Path 605",
	d: "M614.507,205.237h0a6.4,6.4,0,0,1,6.4,6.4v8.647h-12.8v-8.647A6.4,6.4,0,0,1,614.507,205.237Z",
	transform: "translate(-440.737 -148.749)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_606",
	"data-name": "Path 606",
	d: "M648.781,344.373h0a6.4,6.4,0,0,1,6.4,6.4v8.647h-12.8v-8.647A6.4,6.4,0,0,1,648.781,344.373Z",
	transform: "translate(-465.577 -249.591)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_607",
	"data-name": "Path 607",
	d: "M418.655,344.373h0a6.4,6.4,0,0,1,6.4,6.4v8.647h-12.8v-8.647A6.4,6.4,0,0,1,418.655,344.373Z",
	transform: "translate(-298.789 -249.591)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_608",
	"data-name": "Path 608",
	d: "M569.43,520.668l-21.319-9.433a.9.9,0,0,0-.364-.077h-101.6a.9.9,0,0,0-.338.066L422.6,520.657a.9.9,0,0,0,.338,1.731h6.021v30.995h-.674v3.145H563.719v-3.145H562.6V522.388h6.47a.9.9,0,0,0,.363-1.72Zm-8.63,32.715H430.755V522.388H560.8Z",
	transform: "translate(-345.927 -431.985)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1228",
	"data-name": "Rectangle 1228",
	width: 16.396,
	height: 2.695,
	transform: "translate(117.957 70.076)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1229",
	"data-name": "Rectangle 1229",
	width: 16.396,
	height: 2.695,
	transform: "translate(141.989 70.076)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1230",
	"data-name": "Rectangle 1230",
	width: 16.396,
	height: 2.695,
	transform: "translate(166.022 70.076)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1231",
	"data-name": "Rectangle 1231",
	width: 16.396,
	height: 2.695,
	transform: "translate(175.006 108.932)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1232",
	"data-name": "Rectangle 1232",
	width: 16.396,
	height: 2.695,
	transform: "translate(111.443 108.932)",
	fill: "#cacaca"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_609",
	"data-name": "Path 609",
	d: "M395.409,675.05H145.775a.275.275,0,1,1,0-.55H395.409a.275.275,0,1,1,0,.55Z",
	transform: "translate(-145.5 -550.371)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_610",
	"data-name": "Path 610",
	d: "M668.743,386.8c0,.176,0,.355-.006.531,0,.212-.008.421-.016.633-.008.184-.017.366-.027.548-.033.608-.086,1.214-.157,1.822-.017.154-.036.306-.058.46-.016.118-.033.24-.052.361s-.038.27-.061.4q-.066.429-.148.859c-.027.143-.055.286-.085.429-.058.283-.121.57-.187.853-.005.022-.011.047-.016.069-.033.14-.066.278-.1.418-.011.041-.019.08-.033.121-.025.1-.052.209-.08.314-.039.146-.077.289-.119.435-.066.226-.132.449-.2.674-.008.023-.016.047-.022.072-.132.426-.272.848-.427,1.266-.08.22-.165.443-.25.663s-.173.44-.264.658-.179.424-.27.633c-.022.05-.044.1-.069.149-.1.217-.2.429-.3.641,0,0,0,.008-.005.011-.08.171-.165.341-.251.509a.021.021,0,0,1-.005.014c-.083.165-.168.33-.256.493l-.141.267-.016.03c-.176.328-.358.652-.551.974-.041.072-.082.143-.124.212s-.085.143-.129.212q-.041.074-.091.149c-.057.094-.115.19-.176.284-.011.019-.025.039-.036.058l-.314.484c-.13.2-.262.388-.4.581l-2.989,4.784-.129-.107-.036-.033h0l-.118-.1-.325-.275c-.1.1-.2.193-.295.286-.038.039-.08.074-.118.113l-.088.082a28.82,28.82,0,0,1-19.261,8.188h-.008a31.458,31.458,0,0,1-15.7-3.7c-.107-.055-.212-.11-.316-.174-.627-.341-1.241-.7-1.844-1.087l-.008-.006q-1.048-.743-2.048-1.585a30.255,30.255,0,0,1-10.715-24.713c.008-.184.019-.366.033-.55q.067-1,.2-1.99c.025-.185.053-.369.08-.55h58.839q.173,1.263.24,2.54C668.73,385.741,668.743,386.27,668.743,386.8Z",
	transform: "translate(-481.623 -338.861)",
	fill: "#f0f0f0"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_611",
	"data-name": "Path 611",
	d: "M668.658,315.979a29.75,29.75,0,0,0-58.839,0c-.027.182-.055.366-.08.55q-.136.991-.2,1.99H668.9Q668.832,317.244,668.658,315.979Z",
	transform: "translate(-481.819 -272.17)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_612",
	"data-name": "Path 612",
	d: "M679.568,441.077H662.521V427.44c.315-6.232,5.641-6.735,10.646-6.4a6.4,6.4,0,0,1,6.4,6.4Z",
	transform: "translate(-520.221 -366.614)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_613",
	"data-name": "Path 613",
	d: "M623.922,336.128v0s0,0,.005,0Zm-6.856-20.959c-.011.069-.025.138-.036.206.011-.069.025-.137.039-.206Zm-.341,2.54c-.008.1-.016.209-.022.314q.008-.157.025-.314a.416.416,0,0,1,0-.058C616.727,317.671,616.727,317.691,616.724,317.71Zm7.2,18.421s0,0,.005,0l-.005-.005Zm-6.856-20.962c-.011.069-.025.138-.036.206.011-.069.025-.137.039-.206Zm-.363,2.854q.008-.157.025-.314a.416.416,0,0,1,0-.058c0,.019,0,.039-.006.058C616.716,317.814,616.708,317.919,616.7,318.024Zm85.03,50.631a1.9,1.9,0,0,0-.171-.16l0,0-13.629-11.5-.352-.3-1.34-1.131-.336-.283-1.91-1.613-.523-.44-1.081-.914-.553-.468-5.218-4.4-2.992-2.524-.4-.339-8.816-7.439c.135-.193.267-.385.4-.581.1-.162.21-.322.314-.484.011-.019.025-.039.036-.058.06-.094.118-.19.176-.284q.05-.074.091-.149c.044-.069.088-.14.13-.212s.083-.14.124-.212c.193-.322.374-.647.55-.974l.016-.03.141-.267c.088-.162.173-.328.256-.493a.021.021,0,0,0,.005-.014c.085-.168.171-.339.251-.509,0,0,0-.008.005-.011.1-.212.2-.424.3-.641.025-.049.047-.1.069-.148.091-.209.182-.421.27-.633s.179-.438.264-.658.171-.443.251-.663q.227-.632.427-1.266a.638.638,0,0,1,.022-.072c.069-.226.135-.449.2-.674.041-.146.08-.289.118-.435.027-.1.055-.209.08-.314.014-.041.022-.08.033-.121.036-.14.069-.278.1-.418.006-.022.011-.047.017-.069.066-.283.129-.57.187-.853.031-.143.058-.286.085-.429.052-.286.1-.572.149-.859.022-.135.041-.27.061-.4s.036-.242.052-.361c.022-.154.041-.305.058-.46.071-.608.124-1.214.157-1.822.011-.182.019-.363.027-.548.008-.212.014-.421.017-.633,0-.176.005-.355.005-.531,0-.531-.014-1.06-.041-1.591q-.066-1.276-.24-2.54a30.29,30.29,0,0,0-59.94-.55c-.027.182-.055.366-.08.55q-.136.991-.2,1.99c-.014.184-.025.366-.033.55a30.255,30.255,0,0,0,10.714,24.713q1,.842,2.048,1.585s.006,0,.008.005c.234.165.468.328.7.487.377.248.757.49,1.139.721.03.017.061.036.091.052.33.2.663.388,1,.573h0a29.8,29.8,0,0,0,3.851,1.773,30.381,30.381,0,0,0,12.174,1.91h.008a30.209,30.209,0,0,0,13.737-4.065c.608-.352,1.208-.729,1.794-1.131.146-.1.295-.2.438-.3.176-.124.352-.253.529-.383,0,0,0,0,.005,0a.4.4,0,0,1,.041-.03c.118-.091.239-.182.355-.27.03-.022.06-.044.091-.069a.16.16,0,0,0,.022-.019c.069-.049.135-.1.2-.157s.135-.107.2-.162a.252.252,0,0,0,.033-.025l.231-.187c.08-.063.157-.129.231-.193s.151-.127.228-.193.135-.113.2-.173c.022-.017.041-.036.063-.055a.2.2,0,0,1,.027-.022c.091-.077.179-.157.267-.237l.063-.058c.135-.121.27-.242.4-.369l.094-.085.088-.083c.039-.038.08-.074.118-.113.1-.094.2-.19.294-.286l.325.275.118.1h0l.036.033.129.107,1.921,1.624.041.036.033.025.218.184.435.369.435.366.063.052,2.023,1.706.281.237,1.951,1.646,10.1,8.524.352.3L693.1,368.655l3.545,2.992,1.318,1.112a2.789,2.789,0,0,0,3.933-.33,2.708,2.708,0,0,0,.465-.782A2.777,2.777,0,0,0,701.732,368.655Zm-79.726-63.8a22.692,22.692,0,0,1,39.619,10.316c.036.184.069.366.1.55.113.658.2,1.324.245,1.99.014.184.028.366.036.55.025.413.036.828.036,1.241a22.6,22.6,0,0,1-1.227,7.36v0a22.571,22.571,0,0,1-4.12,7.261c-.039.044-.077.091-.118.135-.363.429-.746.842-1.139,1.236,0,0-.005.008-.008.011-.135.135-.272.273-.41.4q-.421.409-.858.779-.656.574-1.346,1.076c-.154.113-.308.223-.465.333s-.311.215-.468.319c-.314.209-.633.41-.955.6-.16.1-.325.19-.487.281s-.328.182-.493.267-.33.173-.5.256c-.333.168-.669.325-1.01.471q-.256.115-.512.215c-.107.044-.212.088-.319.126a1.024,1.024,0,0,1-.13.05q-.087.037-.173.066a.506.506,0,0,1-.058.022c-.118.047-.234.088-.355.129-.173.063-.347.121-.523.176s-.35.113-.526.162-.355.1-.531.151-.355.1-.534.138-.38.094-.572.135c-.168.038-.333.071-.5.1s-.317.061-.474.088c-.22.038-.44.074-.663.1-.121.019-.24.036-.361.047-.052.008-.1.014-.151.019-.154.022-.308.039-.46.052-.041,0-.08.008-.118.011-.168.017-.339.03-.506.044-.36.025-.718.041-1.079.05-.182,0-.366.005-.548.005s-.364,0-.545-.008c0,0,0,0,0,0s0,0-.005,0h-.006a.047.047,0,0,1-.027,0c-.129,0-.259-.006-.385-.014-.094,0-.19-.006-.286-.014q-.194-.008-.388-.025c-.041,0-.083-.005-.124-.008a.383.383,0,0,1-.058-.005c-.132-.011-.267-.022-.4-.036-.066-.005-.135-.011-.2-.019-.2-.022-.4-.047-.6-.074-.226-.028-.451-.061-.674-.1-.1-.014-.207-.033-.308-.052q-.2-.033-.4-.074c-.14-.028-.281-.055-.421-.088-.113-.025-.228-.05-.341-.077-.055-.011-.11-.025-.163-.038-.289-.069-.575-.143-.859-.226-.179-.049-.358-.1-.534-.157-.242-.074-.482-.154-.721-.24-.094-.03-.185-.063-.278-.1s-.184-.066-.278-.1-.171-.063-.253-.1c-.138-.052-.272-.107-.407-.162-.278-.113-.55-.231-.823-.358-.154-.074-.308-.146-.46-.22q-.9-.433-1.764-.963c-.143-.085-.286-.176-.429-.267-.179-.11-.352-.226-.526-.341-.1-.066-.19-.129-.284-.2-.173-.121-.344-.245-.512-.369-.088-.063-.176-.129-.262-.2-.305-.231-.605-.473-.9-.721-.14-.118-.281-.239-.418-.363-.058-.05-.116-.1-.174-.154s-.132-.118-.2-.182l-.005-.005c-.1-.085-.193-.176-.286-.267-.146-.138-.289-.278-.426-.421s-.281-.286-.416-.43-.27-.289-.4-.438-.261-.294-.388-.446-.245-.292-.36-.438q-.421-.52-.8-1.06c-.118-.165-.231-.33-.341-.5s-.231-.344-.339-.518-.22-.349-.325-.528a.062.062,0,0,0-.011-.016c-.206-.35-.4-.7-.589-1.06s-.369-.73-.537-1.1c-.085-.185-.168-.372-.245-.559-.159-.377-.308-.754-.446-1.137-.069-.184-.132-.369-.2-.556a.164.164,0,0,0-.011-.036c-.127-.38-.242-.762-.344-1.148,0-.006,0-.011-.006-.017-.052-.19-.1-.38-.146-.573-.044-.168-.083-.336-.118-.506-.041-.19-.082-.38-.118-.572-.019-.1-.038-.2-.055-.3-.017-.083-.031-.168-.045-.25s-.027-.168-.041-.253q-.041-.252-.074-.5c-.027-.2-.05-.4-.071-.6-.025-.239-.047-.479-.066-.721-.014-.162-.022-.328-.031-.493s-.017-.3-.019-.454a.04.04,0,0,1,0-.025,0,0,0,0,1,0,0v0s0,0,0-.006a0,0,0,0,1,0,0v0c0-.061-.006-.121-.006-.182q-.008-.268-.008-.537c0-.162,0-.322.005-.484q.009-.339.025-.677c0-.049.006-.1.008-.146s.006-.1.008-.146q.008-.157.025-.314a.416.416,0,0,1,0-.058c.008-.118.019-.237.03-.355.022-.237.05-.476.08-.713.016-.118.03-.237.049-.355.011-.083.025-.168.039-.253s.025-.171.041-.256c.019-.113.038-.228.06-.344.011-.069.025-.138.039-.206q.079-.413.173-.826c.063-.278.135-.553.212-.828s.157-.556.245-.834c.041-.14.086-.278.135-.416.091-.278.187-.553.295-.826.05-.135.1-.273.159-.407.11-.272.226-.545.344-.812.06-.135.121-.27.187-.4.124-.267.253-.534.393-.8s.281-.528.43-.787.3-.517.465-.773c.074-.127.157-.256.242-.38.165-.253.339-.506.515-.754C621.219,305.825,621.6,305.333,622.006,304.854Zm-5.282,12.856c-.008.1-.016.209-.022.314q.008-.157.025-.314a.416.416,0,0,1,0-.058C616.727,317.671,616.727,317.691,616.724,317.71Zm.341-2.54c-.011.069-.025.138-.036.206.011-.069.025-.137.039-.206Zm6.856,20.959v0s0,0,.005,0Z",
	transform: "translate(-481.623 -271.361)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_614",
	"data-name": "Path 614",
	d: "M637.856,381.046a22.694,22.694,0,0,1-3.851-30.506q-.651.655-1.258,1.373a22.693,22.693,0,0,0,34.687,29.269q.606-.718,1.142-1.471A22.694,22.694,0,0,1,637.856,381.046Z",
	transform: "translate(-494.764 -315.574)",
	opacity: .3
})));
export default SvgEmptyStatePropertySearch;
